import React from 'react'
import { useDispatch } from 'react-redux'
import Button from '@SiteComponents/Button'
import FeatureCarousel from './FeatureCarousel'
import Checkmark from '@Images/checkmark-tips-preview.svg'

import {
  getForwardingPath,
} from '@SiteModules/Onboarding/actions'

import './TipsPreview.scss'

export const DUMMY_SLIDES: readonly {
  readonly id: number
  readonly title: string
  readonly description: string
}[] = [
  {
    id: 1,
    title: 'Let AI find your best hooks',
    description: 'Don\'t watch hours of footage. Our AI automatically detects high-engagement moments, scores them for virality and cuts them for you.'
  },
  {
    id: 2,
    title: 'Stand out with dynamic captions',
    description: 'Apply trendy, animated subtitle templates in one click. Keep your brand consistent and capture your audience\'s attention instantly.'
  },
  {
    id: 3,
    title: 'Keep your voice, speak any language',
    description: 'Reach a global audience without losing your identity. Our Voice Cloning AI preserves your exact tone, emotion and pacing across 60+ languages.'
  },
]

const TipsPreview: React.FC = () => {
  const dispatch = useDispatch()

  const handleGoToDashboard = () => {
    dispatch(getForwardingPath())
  }

  const renderGlowingCheckmark = () => {
    return (
      <div className="TipsPreview__checkmark-outer">
        <div className="TipsPreview__checkmark-inner">
          <Checkmark />
        </div>
      </div>
    )
  }

  const renderHeader = () => {
    return (
      <div className="TipsPreview__header">
        {renderGlowingCheckmark()}
        <h1 className="TipsPreview__main-heading">Your account is verified! 🎉</h1>
        <p className="TipsPreview__sub-heading">We are finalizing your project in the background.</p>
      </div>
    )
  }

  return (
    <div className="TipsPreview">
      <div className="TipsPreview__main">
        <div className="TipsPreview__backdrop" />
        {renderHeader()}
        <FeatureCarousel />
        <div className="TipsPreview__button-container">
          <div className="TipsPreview__button-glow">
            <Button
              styleType="brand"
              size="large"
              caption="Go to Dashboard"
              data-testid="onboarding-go-to-dashboard"
              onClick={handleGoToDashboard}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipsPreview
